export const role = {
    admin: "admin",
    user: "Пользователь",
    manager: "Менеджер",
    head: "Руководитель (Common)",
    headOfRD: "Руководитель отдела (RD)",
    headOfDC: "Руководитель отдела (DC)",
    administration: "Администрация",
}